<template>
  <section class="bg-white rounded-xl border border-gray-100 shadow-sm p-5 md:p-6">
    <div class="tw-flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900 m-0">Profile completeness</h3>
    </div>
    <div v-if="dataQuality" class="data-quality-cards">
      <EcosystemInfoCard title="Completeness">
        <ul class="completeness-list">
          <li v-for="actor of actorQuality" :key="actor.label">
            <span class="actor-label">{{ actor.label }}</span>
            <span :class="actor.level" class="actor-level">
              {{ actor.level }}
            </span>
          </li>
        </ul>
      </EcosystemInfoCard>

      <EcosystemInfoCard v-for="qualityField of qualityFields" :key="qualityField.label">
        <div class="text-lg">{{ qualityField.amount }}%</div>
        <div class="title">actors have the '{{ qualityField.label }}' property filled in</div>
      </EcosystemInfoCard>
    </div>
  </section>
</template>

<script>
import EcosystemInfoCard from './EcosystemInfoCard.vue';
import { humanize } from '../../../constants/properties';

const toPercentage = int => (int * 100).toFixed();

export default {
  computed: {
    actorQuality() {
      const getLevel = amount => {
        if (amount < 0.5) {
          return 'Low';
        } else if (amount < 0.8) {
          return 'Medium'
        } else {
          return 'High';
        }
      };
      const labels = {
        LegalEntity: 'Organizations',
        Person: 'Individuals',
        Community: 'Communities',
      };
      return Object.entries(this.dataQuality.actor_quality)
        .map(entry => ({
          label: labels[entry[0]],
          level: getLevel(entry[1]),
        }))
    },
    qualityFields() {
      return Object.entries(this.dataQuality.highest_quality_fields)
        .filter(entry => entry[1] > 0)
        .map(entry => ({
          label: humanize(entry[0]),
          amount: toPercentage(entry[1]),
        }))
    }
  },
  components: {
    EcosystemInfoCard
  },
  props: {
    dataQuality: Object,
  },
}
</script>

<style lang="scss" scoped>
.data-quality-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  > * {
    flex: 1 1 200px;
    width: auto;
  }
}

.completeness-list {
  list-style-type: none;
  margin: -8px 0 -4px;
  width: 100%;

  li {
    align-items: center;
    display: flex;
    padding: 8px 4px;

    > * {
      flex: 1;
    }

    + li {
      border-top: 1px solid #f3f4f6;
    }
  }

  .actor-label {
    color: #6b7280;
  }

  .actor-level {
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;

    &.Low {
      color: #dc2626;
    }

    &.Medium {
      color: #2563eb;
    }

    &.High {
      color: #059669;
    }
  }
}
</style>
